import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import { PostLikeFragmentDoc } from '../../../../../fragments/__generated__/postData.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LikePostMutationVariables = Types.Exact<{
  postId: Types.Scalars['ID']['input'];
}>;


export type LikePostMutation = { __typename?: 'Mutation', likePost: { __typename?: 'PostLike', id: string, author: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } } };

export type RemoveLikeFromPostMutationVariables = Types.Exact<{
  likeId: Types.Scalars['ID']['input'];
}>;


export type RemoveLikeFromPostMutation = { __typename?: 'Mutation', removeLikeFromPost: { __typename?: 'PostLike', id: string } };


export const LikePostDocument = gql`
    mutation LikePost($postId: ID!) {
  likePost(data: {postId: $postId}) {
    ...PostLike
  }
}
    ${PostLikeFragmentDoc}`;
export type LikePostMutationFn = Apollo.MutationFunction<LikePostMutation, LikePostMutationVariables>;

/**
 * __useLikePostMutation__
 *
 * To run a mutation, you first call `useLikePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likePostMutation, { data, loading, error }] = useLikePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useLikePostMutation(baseOptions?: Apollo.MutationHookOptions<LikePostMutation, LikePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikePostMutation, LikePostMutationVariables>(LikePostDocument, options);
      }
export type LikePostMutationHookResult = ReturnType<typeof useLikePostMutation>;
export type LikePostMutationResult = Apollo.MutationResult<LikePostMutation>;
export type LikePostMutationOptions = Apollo.BaseMutationOptions<LikePostMutation, LikePostMutationVariables>;
export const RemoveLikeFromPostDocument = gql`
    mutation RemoveLikeFromPost($likeId: ID!) {
  removeLikeFromPost(data: {likeId: $likeId}) {
    id
  }
}
    `;
export type RemoveLikeFromPostMutationFn = Apollo.MutationFunction<RemoveLikeFromPostMutation, RemoveLikeFromPostMutationVariables>;

/**
 * __useRemoveLikeFromPostMutation__
 *
 * To run a mutation, you first call `useRemoveLikeFromPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLikeFromPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLikeFromPostMutation, { data, loading, error }] = useRemoveLikeFromPostMutation({
 *   variables: {
 *      likeId: // value for 'likeId'
 *   },
 * });
 */
export function useRemoveLikeFromPostMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLikeFromPostMutation, RemoveLikeFromPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLikeFromPostMutation, RemoveLikeFromPostMutationVariables>(RemoveLikeFromPostDocument, options);
      }
export type RemoveLikeFromPostMutationHookResult = ReturnType<typeof useRemoveLikeFromPostMutation>;
export type RemoveLikeFromPostMutationResult = Apollo.MutationResult<RemoveLikeFromPostMutation>;
export type RemoveLikeFromPostMutationOptions = Apollo.BaseMutationOptions<RemoveLikeFromPostMutation, RemoveLikeFromPostMutationVariables>;